// extracted by mini-css-extract-plugin
module.exports = {"base":"Radio_base__2X_gW","isActive":"Radio_isActive__vFWD6","input":"Radio_input__1d1zg","label":"Radio_label__2Qt5a"};